module.exports = __webpack_public_path__ + "static/media/brightcubes.c21efe32.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/brightcubes.webp
// module id = 774
// module chunks = 0